import React, { useState } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
    <div className="container">
        <div className="faqcontainer">
    <h1>How do I get support if I encounter an issue with the payroll system?</h1>
    <h2 className="faq-heading">Our dedicated support team is available 24/7 to assist you. Reach us through chat, email, or phone, and we’ll resolve your concerns promptly.

</h2>
    <section id="faq">
      
      <ul className="faq-list">
        <li className="faq-item">
          <button 
            className="faq-title" 
            onClick={() => toggleFAQ(1)}
          >
            <strong>How does your system handle country-specific compliance?</strong>
            <span className={`toggle-icon ${activeIndex === 1 ? 'active' : ''}`}>↓</span>
          </button>
          {activeIndex === 1 && (
            <ul className="faq-sub-questions">
              <li>What specific countries does your system comply with?</li>
              <li>How often is the compliance information updated?</li>
              <li>Are there any country-specific features or restrictions?</li>
            </ul>
          )}
        </li>
        <li className="faq-item">
          <button 
            className="faq-title" 
            onClick={() => toggleFAQ(2)}
          >
            <strong>Can you support remote teams and contractors?</strong>
            <span className={`toggle-icon ${activeIndex === 2 ? 'active' : ''}`}>↓</span>
          </button>
          {activeIndex === 2 && (
            <ul className="faq-sub-questions">
              <li>What tools do you provide for remote teams?</li>
              <li>How do you manage contractor payments and taxes?</li>
              <li>Do you offer integration with remote work software?</li>
            </ul>
          )}
        </li>
        <li className="faq-item">
          <button 
            className="faq-title" 
            onClick={() => toggleFAQ(3)}
          >
            <strong>What is your data security policy?</strong>
            <span className={`toggle-icon ${activeIndex === 3 ? 'active' : ''}`}>↓</span>
          </button>
          {activeIndex === 3 && (
            <ul className="faq-sub-questions">
              <li>What encryption methods are used for data storage?</li>
              <li>How often are security audits conducted?</li>
              <li>Do you comply with GDPR or other privacy regulations?</li>
            </ul>
          )}
        </li>
        <li className="faq-item">
          <button 
            className="faq-title" 
            onClick={() => toggleFAQ(4)}
          >
            <strong>How do clients get support?</strong>
            <span className={`toggle-icon ${activeIndex === 4 ? 'active' : ''}`}>↓</span>
          </button>
          {activeIndex === 4 && (
            <ul className="faq-sub-questions">
              <li>What support channels are available (e.g., email, chat, phone)?</li>
              <li>Are there any self-help resources or knowledge bases?</li>
              <li>How quickly can clients expect a response?</li>
            </ul>
          )}
        </li>
      </ul>
    </section>
    </div>
    </div>
    </>
  );
};

export default FAQ;
